import { useDemoFetcherWithSwr } from "@/api";
import { userAtom } from "@/atoms/userAtom";
import { useAtomValue } from "jotai";

/**
 * AIレベル（累計ポイント・レベル・ゲージ）を取得するカスタムフック
 *
 * ログイン済みユーザーのみ取得する。提案画面遷移時に手動取得できるよう
 * `refresh`（SWR の mutate）を公開する。
 */
export const useAiLevel = () => {
  const user = useAtomValue(userAtom);
  const enabled = !!user?.userId;

  const { data, error, isLoading, mutate } = useDemoFetcherWithSwr({
    apiName: "user_interaction_logger",
    serviceName: "default",
    operationId: "getUserAiLevel",
    requestParameters: { userId: user?.userId || "" },
    enabled,
    swrConfiguration: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false
    }
  });

  return {
    level: data?.level ?? 0,
    gauge: data?.gauge ?? 0,
    totalPt: data?.total_pt ?? 0,
    isLoading: enabled ? isLoading : false,
    error,
    // 提案画面遷移時に手動取得するための再検証関数（最新の UserAILevel を返す）
    refresh: mutate
  };
};
